import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import AudioTagList from "./audio-tag-list.vue";
import AudioAssetList from "./audio-asset-list.vue";
import { tabNameList } from "./config";
export default defineComponent({
    props: {
        resources: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        currentTab: {
            type: definePropType(Object),
            default: function() {
                return {
                    key: "",
                    tagId: "",
                    search: "",
                    componentsTitle: "",
                    type: 0
                };
            }
        }
    },
    components: {
        AudioTagList: AudioTagList,
        AudioAssetList: AudioAssetList
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleAddResource = function(res) {
            emit("addResource", res);
        };
        var viewTagAllData = function(tagInfo) {
            emit("viewTagAllData", tagInfo);
        };
        var getCommonHotComponents = function() {
            emit("backCommonHotComponents");
        };
        return {
            tabNameList: tabNameList,
            handleAddResource: handleAddResource,
            viewTagAllData: viewTagAllData,
            getCommonHotComponents: getCommonHotComponents
        };
    }
});
